module.exports = __webpack_public_path__ + "img/qrcodetype2.f6d4b8a3.png";